/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Intermediary } from './intermediary';
import { PolicyRole } from './policyRole';
import { PremiumDetail } from './premiumDetail';
import { Risk } from './risk';

/**
 * This resource provides generic data from the policy as contractual information between MAPFRE and the Client, such as its branch, product, coverage and associated risks, payment metohds ,status, and dates of issue, renewal, expiration, etc.
 */
export interface PolicyClient {
  /**
   * Identifier of the company owns the final contract
   */
  companyId?: string;
  /**
   * Numerical reference that MAPFRE assigns to each insurance contract to identify it
   */
  policyId?: string;
  /**
   * Numerical reference that MAPFRE gives to client to identify his policy
   */
  policyNumber?: string;
  /**
   * Indicates the policy sector code. E.g: HomePRHLine, PMILine
   */
  sectorCode?: PolicyClient.SectorCodeEnum;
  /**
   * Indicates the policy branch code
   */
  branchCode?: string;
  /**
   * Date in which the policy is issued (time stamp)
   */
  captureDate?: Date;
  /**
   * Date in which the policy is effective
   */
  effectiveDate?: Date;
  /**
   * Date in which the policy is expired
   */
  expirationDate?: Date;
  /**
   * policy's product code. E.g: HomePRH, PersonalMotorIT
   */
  productCode?: string;
  /**
   * policy's product name
   */
  productName?: string;
  /**
   * Indicates the policy channel
   */
  distributionChannelCode?: string;
  /**
   * Date in which the policy will be renewal
   */
  renewalDate?: Date;
  /**
   * Indicates the campaign related with the policy
   */
  campaignId?: string;
  /**
   * Indicates the coinsurance type code for the policy
   */
  coinsuranceTypeCode?: string;
  /**
   * Indicates the endorsement number in which is the policy
   */
  endorsementNumber?: string;
  /**
   * Checks if the policy is inactive
   */
  inactiveInd?: boolean;
  /**
   * Checks if the renewal opportunity for the policy has been created
   */
  renewalOppGeneratedInd?: boolean;
  /**
   * Policy renewal situation Code (New or Renewed)
   */
  renewalStatusCode?: string;
  /**
   * policy status code
   */
  policyStatusCode?: string;
  /**
   * Flag to indicate if the Policy has an technical control by MAPFRE.
   */
  policyRetainedInd?: boolean;
  risks?: Array<Risk>;
  premiumDetail?: PremiumDetail;
  intermediary?: Intermediary;
  /**
   * List Relating the policy with the correspondent policy roles
   */
  policyRoles?: Array<PolicyRole>;
}
export namespace PolicyClient {
  export type SectorCodeEnum = 'HomePRHLine' | 'PMILine';
  export const SectorCodeEnum = {
    HomePRHLine: 'HomePRHLine' as SectorCodeEnum,
    PMILine: 'PMILine' as SectorCodeEnum,
  };
}
